import type { LocationDescriptor } from 'history';
import type { HTMLAttributes } from 'react';

export interface CardItemShelterData {
  name?: string;
  image?: string;
  location?: string;
  languages?: string;
  link?: LocationDescriptor;
  loading?: boolean;
}

export interface CardItemShelterProps extends HTMLAttributes<HTMLDivElement>, CardItemShelterData {}
